<template>
  <div class="footer">
    <div class="section last">

      <div class="section color">
        <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pb-0" style="border-bottom: none;">
          <div class="w-layout-grid grid-2-colum mt-0 color-footer" style="grid-column-gap: unset;">
            <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
                 style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
            ">
              <div class="item justify-content-end">
                <a @click="goHome" id="w-node-bd35c41e-61b3-501a-b5b5-76a67d389e27-e94b0a3f" class="navbar-logo-link w-nav-brand"><img src="../../../../../public/images/kolobok.svg" loading="lazy" alt="" class="navbar-logo"></a>
              </div>
            </div>

            <div id="w-node-_8a817dec-33d8-ba64-0999-5e0ddc2f3a91-8870dddc"
                 class="grid-colum right flex between direction-row gap-10"
                 style="padding: 25px 25px 35px; gap: 10px;">
              <div>
                <p class="plane-text big">Поддержка клиентов — бесплатно, круглосуточно</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Footer',
  methods: {
    goToDocument(name_doc) {
      this.$router.push('/documents/' + name_doc);
    },
    goHome() {
      this.$router.push('/');
    },
    goToPolicyPersonalData() {
      this.$router.push('/documents/privacy-policy');
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style>
.footer a {
  color: black;
}
</style>
